import React, { useEffect } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import FogOverlay from './FogOverlay';

import 'leaflet/dist/leaflet.css';

const DEFAULT_CENTER = [40.7128, -74.006];
const DEFAULT_ZOOM = 13;
const MIN_ZOOM = 3;
const MAX_BOUNDS = [
  [-85, -180],
  [85, 180],
];

function toLeaflet(coord) {
  if (coord.latitude != null) return [coord.latitude, coord.longitude];
  return [coord[1], coord[0]];
}

function FitBounds({ routes }) {
  const map = useMap();

  useEffect(() => {
    if (!routes || routes.length === 0) return;

    const allCoords = routes.flatMap((r) => {
      if (!r.route_data?.coordinates) return [];
      return r.route_data.coordinates.map(toLeaflet);
    });

    if (allCoords.length > 0) {
      const bounds = L.latLngBounds(allCoords);
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 15 });
    }
  }, [routes, map]);

  return null;
}

const ExplorationMap = ({ routes }) => {
  return (
    <MapContainer
      center={DEFAULT_CENTER}
      zoom={DEFAULT_ZOOM}
      minZoom={MIN_ZOOM}
      maxBounds={MAX_BOUNDS}
      maxBoundsViscosity={1.0}
      worldCopyJump={false}
      className="w-full h-full"
      zoomControl={true}
      attributionControl={false}
      style={{ background: '#e5e7eb' }}
    >
      <TileLayer
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        noWrap={true}
      />

      <FogOverlay routes={routes} />
      <FitBounds routes={routes} />
    </MapContainer>
  );
};

export default ExplorationMap;
